import React, {
  useState,
  useEffect,
} from 'react';
import {
  makeStyles,
  createStyles,
} from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import moment from 'moment';
import Moment from 'react-moment';
import Grid from '@material-ui/core/Grid';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ReportCardsDetailsTarget from './ReportCardsDetailsTarget';
import ReportCardsDetailsSummaryComment from './ReportCardsDetailsSummaryComment';

const useStyles = makeStyles(theme => createStyles({
  heading: {
    margin: '20px 0',
  },
  headingBack: {
    textAlign: 'left',
    '& span': {
      verticalAlign: 'top',
    },
  },
  headingDate: {
    textAlign: 'center',
    fontWeight: 'bold',
  },
  headingNext: {
    textAlign: 'right',
    '& span': {
      verticalAlign: 'top',
    },
  },
  todayButtonWrapper: {
    fontSize: '0.8em',
  },
}));

export default function ReportCardsDetailsTargets({
  data,
  meta,
}) {
  const classes = useStyles();
  const { t } = useTranslation(undefined, { useSuspense: false });
  const today = moment().format('YYYY-MM-DD');
  const startDate = data.start_date;
  const endDate = data.end_date;

  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedTargetIndex, setSelectedTargetIndex] = useState(0);

  useEffect(() => {
    setSelectedDate(moment(data.start_date).format('YYYY-MM-DD'));
  }, [data]);

  const onTabChange = (event, value) => {
    setSelectedTargetIndex(value);
  };

  const onBackClick = (event) => {
    event.preventDefault();

    let nextAvailableDate = moment(selectedDate).subtract(1, 'day');

    if (meta?.forbidden_days_of_week?.length > 0) {
      const forbiddenDaysOfWeek = meta.forbidden_days_of_week;
      let nextAvailableDateIsValid = forbiddenDaysOfWeek.indexOf(nextAvailableDate.isoWeekday()) === -1;
      while (!nextAvailableDateIsValid) {
        nextAvailableDate = nextAvailableDate.subtract(1, 'day');
        nextAvailableDateIsValid = forbiddenDaysOfWeek.indexOf(nextAvailableDate.isoWeekday()) === -1;
      }
    }

    setSelectedDate(nextAvailableDate.format('YYYY-MM-DD'));
  };

  const onNextClick = (event) => {
    event.preventDefault();

    let nextAvailableDate = moment(selectedDate).add(1, 'day');

    if (meta?.forbidden_days_of_week?.length > 0) {
      const forbiddenDaysOfWeek = meta.forbidden_days_of_week;
      let nextAvailableDateIsValid = forbiddenDaysOfWeek.indexOf(nextAvailableDate.isoWeekday()) === -1;
      while (!nextAvailableDateIsValid) {
        nextAvailableDate = nextAvailableDate.add(1, 'day');
        nextAvailableDateIsValid = forbiddenDaysOfWeek.indexOf(nextAvailableDate.isoWeekday()) === -1;
      }
    }

    setSelectedDate(nextAvailableDate.format('YYYY-MM-DD'));
  };

  const onBackTodayClick = (event) => {
    event.preventDefault();

    setSelectedDate(today);
  };

  const onNextTodayClick = (event) => {
    event.preventDefault();

    setSelectedDate(today);
  };

  const targets = data.targets;
  if (!targets || targets.length === 0) {
    return null;
  }

  const showBack = selectedDate > startDate;
  const showNext = selectedDate < endDate;
  const showBackToday = selectedDate !== today && selectedDate > today && today > startDate;
  const showNextToday = selectedDate !== today && selectedDate < today && today < endDate;

  return (
    <div className="report-cards-details-targets">
      <Grid container className={classes.heading}>
        <Grid item xs={4} className={classes.headingBack}>
          {showBack && (
            <a href="#" onClick={onBackClick}>
              <ChevronLeftIcon />
              <span>{t('Back')}</span>
            </a>
          )}
          {showBackToday && (
            <div className={classes.todayButtonWrapper}>
              <a href="#" onClick={onBackTodayClick}>
                <ChevronLeftIcon fontSize="small" />
                <span>{t('Today')}</span>
              </a>
            </div>
          )}
        </Grid>
        <Grid item xs={4} className={classes.headingDate}>
          <Moment format={'ddd Do MMMM'}>{selectedDate}</Moment>
        </Grid>
        <Grid item xs={4} className={classes.headingNext}>
          {showNext && (
            <a href="#" onClick={onNextClick}>
              <span>{t('Next')}</span>
              <ChevronRightIcon />
            </a>
          )}
          {showNextToday && (
            <div className={classes.todayButtonWrapper}>
              <a href="#" onClick={onNextTodayClick}>
                <span>{t('Today')}</span>
                <ChevronRightIcon fontSize="small" />
              </a>
            </div>
          )}
        </Grid>
      </Grid>
      <Tabs
        value={selectedTargetIndex}
        onChange={onTabChange}
        indicatorColor="secondary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {targets.map((target, index) => {
          const label = t('Target') + ' ' + (index + 1);
          return (
            <Tab key={target.id} label={label} />
          );
        })}
        <Tab label={t('End of day summary')} />
      </Tabs>
      {!targets[selectedTargetIndex] && (
        <ReportCardsDetailsSummaryComment
          id={data.id}
          selectedDate={selectedDate}
        />
      )}
      {!!targets[selectedTargetIndex] && (
        <ReportCardsDetailsTarget
          id={targets[selectedTargetIndex].id}
          data={targets[selectedTargetIndex]}
          selectedDate={selectedDate}
        />
      )}
    </div>
  );
}

